<template lang="pug">
.compate-input(:class='{disabled:disabled}')
  label(v-if='label')
    span.label {{label}}
    span.difference(v-if='diff!=null', :class='color')
      | {{ arrow }} {{ diff }}
    span.previous ({{previous}})
  input(v-model='inner_value', @keydown='keydown_handler', :disabled='disabled')
</template>

<script>
export default {
  name: 'compare-input',
  props: {
    label: String,
    value: null,
    previous: Number,
    allowDot: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    diff() {
      if (this.previous !== undefined && this.inner_value.length) {
        const value = (+this.inner_value || 0) - (this.previous || 0) || 0
        return Math.round(value * 100) / 100
      }
      return null
    },
    color() {
      if (this.diff < 0)
        return 'red'
      else if (this.diff > 0)
        return 'green'
      return 'yellow'
    },
    arrow() {
      if (this.diff < 0)
        return '⬇'
      else if (this.diff > 0)
        return '⬆'
      return ''
    },
  },
  mounted() {
    this.inner_value = this.value || '0'
  },
  data() {
    return {
      inner_value: 0,
    }
  },
  watch: {
    value() {
      this.inner_value = this.value || '0'
    },
    inner_value() {
      if (this.allowDot)
        this.$emit('input', parseFloat(this.inner_value))
      else
        this.$emit('input', parseInt(this.inner_value, 10))
    },
  },
  methods: {
    keydown_handler(e) {
      if ((e.keyCode >= 48 && e.keyCode < 58)
       || (e.keyCode >= 96 && e.keyCode <= 105)
       || (this.inner_value && !this.inner_value.toString().includes('.') && this.allowDot && e.key === '.'))
        return
      if (['Tab', 'Enter', 'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(e.key))
        return
      e.preventDefault()
    },
  },
}
</script>



// WEBPACK FOOTER //
// CompareInput.vue?521f58ac